module.exports = __webpack_public_path__ + "static/media/ad.e12bee1f.svg";